import React from 'react';
import Header from 'components/Header';
import { Navigation } from 'components/Navigation/Navigation';
import { BodyContainer, MainContainer, PageContainer } from './Page.styles';

const Page: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <PageContainer>
      <Navigation />
      <BodyContainer>
        <Header />
        <MainContainer>{children}</MainContainer>
      </BodyContainer>
    </PageContainer>
  );
};

export default Page;
